import { createTheme } from '@mui/material';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#3293DB',
    },
    secondary: {
      main: '#52AB98',
    },
    success: {
      main: '#4caf50',
    },
    error: {
      main: '#f44336',
    },
  },
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: 'outlined' },
          style: {
            padding: '10px 22px',
            boxShadow: 'unset',
          },
        },
        {
          props: { variant: 'contained' },
          style: {
            padding: '10px 22px',
            boxShadow: 'unset',
          },
        },
      ],
    },
  },
  typography: {
    fontFamily: 'Inter, sans-serif',
    allVariants: {
      lineHeight: '17px',
    },
    h1: {
      fontSize: '24px',
      fontWeight: 600,
      lineHeight: '29px',
    },
    h3: {
      fontSize: '20px',
      fontWeight: 600,
      lineHeight: '29px',
    },
  },
});
